import AnimatedSection from '../common/AnimatedSection'
import { aboutVisionIconMap } from '../icons/AboutVisionIcons'
import { aboutVisionSection } from '../../data/aboutPageData'

function AboutVisionSection() {
  const { label, titleLine1, titleAccent, image, imageAlt, paragraphs, items } = aboutVisionSection

  return (
    <AnimatedSection className="about-vision-section" id="our-vision">
      <div className="container corp-container">
        <div className="about-vision-hero">
          <div className="about-vision-copy">
            <div className="about-vision-label">
              <span className="about-vision-label-line" aria-hidden="true" />
              <span>{label}</span>
            </div>

            <h2 className="about-vision-title">
              {titleLine1}
              <span>{titleAccent}</span>
            </h2>

            <span className="about-vision-accent" aria-hidden="true" />

            {paragraphs.map((paragraph) => (
              <p className="about-vision-text" key={paragraph.slice(0, 32)}>
                {paragraph}
              </p>
            ))}
          </div>

          <div className="about-vision-visual">
            <span className="about-vision-visual-border" aria-hidden="true" />
            <img src={image} alt={imageAlt} loading="lazy" />
          </div>
        </div>

        <div className="about-vision-grid" role="list">
          {items.map((item) => {
            const Icon = aboutVisionIconMap[item.icon]

            return (
              <article className="about-vision-card" key={item.id} role="listitem">
                <span className="about-vision-card-icon">
                  <Icon />
                </span>
                <div className="about-vision-card-copy">
                  <h3>{item.title}</h3>
                  <span className="about-vision-card-divider" aria-hidden="true" />
                  <p>{item.text}</p>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AboutVisionSection
